import { render, staticRenderFns } from "./PropertyBrowser.yaml?vue&type=template&id=176a128a&component"
import script from "./PropertyBrowser.yaml?vue&type=script&lang=ts&component"
export * from "./PropertyBrowser.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports